import { highlightSegments } from './library-logic';

/**
 * Text with the search terms marked (prototype `hl()` and the `mark`
 * rule in `docs/requirement-library/prototype/selection.css`).
 */
export function Highlight({ text, terms }: { text: string; terms: ReadonlyArray<string> }) {
  if (terms.length === 0) return <>{text}</>;
  return (
    <>
      {highlightSegments(text, terms).map((seg, i) =>
        seg.match ? (
          <mark key={i} className="rounded-[2px] bg-cite-highlight px-px text-inherit">
            {seg.text}
          </mark>
        ) : (
          <span key={i}>{seg.text}</span>
        ),
      )}
    </>
  );
}
